export const INTEGRATION_BASE_URL = '/admin/integrations';
export const ENTERPRISE_API_ROOT = 'enterprises';
export const GET_ZOOM_ACCOUNT_API = 'zoom/account';
export const GOOGLE_MEET_ACCOUNTS_API = 'google_meet';
export const TEAMS_VIDEO_ACCOUNTS_API = 'teams_video';
export const GET_SLACK_ACCOUNT_API = 'slack/guide_account_mapping';
export const GET_SLACK_CHANNELS_API = 'slack_channels_and_ids';
export const ZOOM_ACCOUNT_API = 'integrations/zoom/';
export const EXTERNAL_SERVICE_SETTINGS_API_ROOT = 'external_service_settings';
export const EXTERNAL_SERVICE_SETTINGS_API = 'external_service_sync';
export const CREATE_BAMBOO_SETTINGS = 'create_bamboo_setting';
export const USERS_API_ROOT = 'users';
export const USER_TAGS_API_ROOT = 'object_tags';
export const USER_SYNC_DATA_PATH = '/api/salesforce/batch_results/UserGroups';
export const DELETE_GUIDE_COMPLETION_SLACK_MAPPINGS = 'delete_guide_completion_slack_mapping';
export const GO1_API_PATH = 'go1';

export const MIX_PANEL_EVENTS = {
  ZOOM: {
    LEARN_MORE: 'admin_settings_integrations_learn_more_zoom',
    EDIT: 'admin_settings_integrations_edit_zoom',
    DELETE: 'admin_settings_integrations_delete_zoom',
    ADD: 'admin_settings_integrations_add_zoom',
  },
  GOOGLE_MEET: {
    LEARN_MORE: 'admin_settings_integrations_learn_more_google_meet',
    EDIT: 'admin_settings_integrations_edit_google_meet',
    DELETE: 'admin_settings_integrations_delete_google_meet',
    ADD: 'admin_settings_integrations_add_google_meet',
    ENABLE: 'admin_settings_integrations_enable_google_meet',
    DISABLE: 'admin_settings_integrations_disable_google_meet',
  },
  ZAPIER: {
    LEARN_MORE: 'admin_settings_integrations_learn_more_zapier',
  },
  WORKDAY: {
    LEARN_MORE: 'admin_settings_integrations_learn_more_workday',
    ENABLE: 'admin_settings_integrations_enable_workday',
    DISABLE: 'admin_settings_integrations_disable_workday',
    OVERRIDE_GROUPS: 'admin_settings_integrations_override_groups_workday', // with Boolean value
    OVERRIDE_MANAGERS: 'admin_settings_integrations_override_managers_workday', // with Boolean value
    SYNC: 'admin_settings_integrations_sync_workday',
    DOWNLOAD: 'admin_settings_integration_download_workday',
  },
  HIBOB: {
    LEARN_MORE: 'admin_settings_integrations_learn_more_hibob',
    ENABLE: 'admin_settings_integrations_enable_hibob',
    DISABLE: 'admin_settings_integrations_disable_hibob',
    OVERRIDE_GROUPS: 'admin_settings_integrations_override_groups_hibob', // with Boolean value
    OVERRIDE_MANAGERS: 'admin_settings_integrations_override_managers_hibob', // with Boolean value
    SYNC: 'admin_settings_integrations_sync_hibob',
    DOWNLOAD: 'admin_settings_integration_download_hibob',
  },
  UDEMY: {
    LEARN_MORE: 'admin_settings_integrations_learn_more_udemy',
    ENABLE: 'admin_settings_integrations_enable_udemy', // with connected status
    DISABLE: 'admin_settings_integrations_disable_udemy', // with connected status
  },
  SLACK: {
    LEARN_MORE: 'admin_settings_integrations_learn_more_slack',
    ENABLE: 'admin_settings_integrations_enable_slack',
    DISABLE: 'admin_settings_integrations_disable_slack',
    ACTION: 'admin_settings_integrations_action_slack', // key/pair value
  },
  SALESFORCE: {
    LEARN_MORE: 'admin_settings_integrations_learn_more_salesforce',
    ENABLE: 'admin_settings_integrations_enable_salesforce', // with environment value
    DISABLE: 'admin_settings_integrations_disable_salesforce', // with environment value
    DOWNLOAD: 'admin_settings_integrations_download_salesforce', // with environment value
    SYNC: 'admin_settings_integrations_sync_salesforce', // with environment value
    FILTER: 'admin_settings_integrations_filter_salesforce', // with environment value
  },
  BAMBOO: {
    LEARN_MORE: 'admin_settings_integrations_learn_more_bamboo',
    IMPORT: 'admin_settings_integrations_import_bamboo',
    DISABLE: 'admin_settings_integrations_disable_bamboo',
    SUBDOMAIN: 'admin_settings_integrations_subdomain_bamboo', // with String value
    FULL_TIME: 'admin_settings_integrations_full_time_bamboo', // with Boolean value
    PART_TIME: 'admin_settings_integrations_part_time_bamboo', // with Boolean value
    OVERRIDE_MANAGERS: 'admin_settings_integrations_override_managers_bamboo', // with Boolean value
    DOWNLOAD: 'admin_settings_integrations_download_bamboo',
    SYNC: 'admin_settings_integrations_sync_bamboo',
  },
  OUTLOOK: {
    LEARN_MORE: 'admin_settings_integrations_learn_more_outlook',
    ENABLE: 'admin_settings_integrations_enable_outlook',
    DISABLE: 'admin_settings_integrations_disable_outlook',
  },
  GOOGLECALENDAR: {
    LEARN_MORE: 'admin_settings_integrations_learn_more_google_calendar',
    ENABLE: 'admin_settings_integrations_enable_google_calendar',
    DISABLE: 'admin_settings_integrations_disable_google_calendar',
  },
  MANAGED_INTEGRATION: {
    ENABLE: 'admin_settings_integrations_enable_managed_integration',
    DISABLE: 'admin_settings_integrations_disable_managed_integration',
    OVERRIDE_GROUPS: 'admin_settings_integrations_override_groups',
    OVERRIDE_MANAGERS: 'admin_settings_integrations_override_managers',
  },
  CONTENT_PROVIDER_INTEGRATION: {
    ENABLE: 'admin_settings_integrations_enable_content_provider_integration',
    DISABLE: 'admin_settings_integrations_disable_content_provider_integration',
  },
  NATIVE_HRIS_INTEGRATION: {
    ENABLE: 'admin_settings_integrations_enable_native_hris_integration',
    DISABLE: 'admin_settings_integrations_disable_native_hris_integration',
    OVERRIDE_GROUPS: 'admin_settings_integrations_override_groups',
    OVERRIDE_MANAGERS: 'admin_settings_integrations_override_managers',
  },
  WORKRAMP_CONTENT_INTEGRATION: {
    LEARN_MORE: 'admin_settings_integrations_learn_more_workramp_content',
    ENABLE: 'admin_settings_integrations_enable_workramp_content',
    DISABLE: 'admin_settings_integrations_disable_workramp_content',
  },
};

export const CONTENT_PROVIDER_INTEGRATION_FIELDS = {
  ACCESS_TOKEN: 'accessToken',
  CLIENT_ID: 'clientId',
  CLIENT_SECRET: 'clientSecret',
  CONTENT_PROVIDER_SUBDOMAIN: 'contentProviderSubdomain',
  ENABLED: 'enabled',
};
